
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("a5txT", function(module, exports) {

var $7xVCs = parcelRequire("7xVCs");

const $82982cff56793d8b$var$standalonePageTreeStateUpdater = new (0, $7xVCs.PageTreeStateUpdater)();
const $82982cff56793d8b$export$19e3952b1a66ecb = ()=>$82982cff56793d8b$var$standalonePageTreeStateUpdater;
module.exports["getStandalonePageTreeStateUpdater"] = $82982cff56793d8b$export$19e3952b1a66ecb;

});

parcelRegister("7xVCs", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");


var $kNIYN = parcelRequire("kNIYN");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $kNIYN.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("30qWc", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $308Wd = parcelRequire("308Wd");

const $9acca7871dfd8a5c$export$a59d7e865b63a081 = (0, $3u0dr.isReactCompilerActiveV2)() ? function MutationInterop(t0) {
    const $ = (0, $bDgLe.c)(8);
    let children;
    let mutation;
    let props;
    if ($[0] !== t0) {
        ({ children: children, mutation: mutation, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = mutation;
        $[3] = props;
    } else {
        children = $[1];
        mutation = $[2];
        props = $[3];
    }
    const [mutate, result] = (0, $308Wd.useMutationInterop)(mutation, props);
    let t1;
    if ($[4] !== children || $[5] !== mutate || $[6] !== result) {
        t1 = children(mutate, result);
        $[4] = children;
        $[5] = mutate;
        $[6] = result;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
} : function MutationInterop({ children: children, mutation: mutation, ...props }) {
    const [mutate, result] = (0, $308Wd.useMutationInterop)(mutation, props);
    return children(mutate, result);
};
module.exports["MutationInterop"] = $9acca7871dfd8a5c$export$a59d7e865b63a081;

});

parcelRegister("b1HmN", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $80716d6d5be0d4f0$export$fff6e0d8ba6c4cc6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ishvT",
    name: "LoadableChangeEditionNotificationDialog",
    loader: async ()=>(await (parcelRequire("gLBnb"))).ChangeEditionNotificationDialog
});
module.exports["LoadableChangeEditionNotificationDialog"] = $80716d6d5be0d4f0$export$fff6e0d8ba6c4cc6;

});

parcelRegister("gLBnb", function(module, exports) {

let $c34e069a662c0fae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c34e069a662c0fae$var$load("hhss7"),
    $c34e069a662c0fae$var$load("kSVGa")
]).then(()=>parcelRequire('5BDEU'));

});

parcelRegister("5ZPtT", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5ea117b10605f60a$export$6d1402fb58384e4f = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "OP-5u",
    name: "PageLayout",
    loader: async ()=>(await (parcelRequire("3BbMs"))).PageLayout
});
module.exports["PageLayout"] = $5ea117b10605f60a$export$6d1402fb58384e4f;

});

parcelRegister("3BbMs", function(module, exports) {

let $29edf730010feabd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $29edf730010feabd$var$load("ahbxG"),
    $29edf730010feabd$var$load("15c4x"),
    $29edf730010feabd$var$load("dPFEi"),
    $29edf730010feabd$var$load("h7ECu"),
    $29edf730010feabd$var$load("ifDx2"),
    $29edf730010feabd$var$load("7Fou0"),
    $29edf730010feabd$var$load("cGTwy"),
    $29edf730010feabd$var$load("jkBWf"),
    $29edf730010feabd$var$load("6T9n5"),
    $29edf730010feabd$var$load("c9e1W"),
    $29edf730010feabd$var$load("6vqGz"),
    $29edf730010feabd$var$load("gpF3C"),
    $29edf730010feabd$var$load("bfTdl"),
    $29edf730010feabd$var$load("2cSY3"),
    $29edf730010feabd$var$load("35Mi3"),
    $29edf730010feabd$var$load("c5pF4"),
    $29edf730010feabd$var$load("4evdD"),
    $29edf730010feabd$var$load("uvm9i"),
    $29edf730010feabd$var$load("hnd6n"),
    $29edf730010feabd$var$load("Vd4qA"),
    $29edf730010feabd$var$load("6wr18"),
    $29edf730010feabd$var$load("jzxVe"),
    $29edf730010feabd$var$load("1Efpv"),
    $29edf730010feabd$var$load("5nbvZ"),
    $29edf730010feabd$var$load("51Q7N"),
    $29edf730010feabd$var$load("hohnS"),
    $29edf730010feabd$var$load("eRFbs"),
    $29edf730010feabd$var$load("cXgsM"),
    $29edf730010feabd$var$load("8RMwa"),
    $29edf730010feabd$var$load("2putD"),
    $29edf730010feabd$var$load("llcQo"),
    $29edf730010feabd$var$load("6Sqrl"),
    $29edf730010feabd$var$load("ay0l9"),
    $29edf730010feabd$var$load("dgerE"),
    $29edf730010feabd$var$load("VXbA1"),
    $29edf730010feabd$var$load("el56J"),
    $29edf730010feabd$var$load("2PVCX"),
    $29edf730010feabd$var$load("aEiTV"),
    $29edf730010feabd$var$load("1qlDN"),
    $29edf730010feabd$var$load("1yVM6"),
    $29edf730010feabd$var$load("ea3NB"),
    $29edf730010feabd$var$load("bjgFk"),
    $29edf730010feabd$var$load("djEIy"),
    $29edf730010feabd$var$load("aLbuU"),
    $29edf730010feabd$var$load("1SVGS"),
    $29edf730010feabd$var$load("dq8fV"),
    $29edf730010feabd$var$load("ffEVr"),
    $29edf730010feabd$var$load("gAw1M"),
    $29edf730010feabd$var$load("gS29N"),
    $29edf730010feabd$var$load("Wowvf"),
    $29edf730010feabd$var$load("dXOu8"),
    $29edf730010feabd$var$load("8jzRX"),
    $29edf730010feabd$var$load("9vN6N"),
    $29edf730010feabd$var$load("29WXq"),
    $29edf730010feabd$var$load("vsgOr"),
    $29edf730010feabd$var$load("i313S"),
    $29edf730010feabd$var$load("hhss7"),
    $29edf730010feabd$var$load("aAWLw"),
    $29edf730010feabd$var$load("7EorR"),
    $29edf730010feabd$var$load("gmHzx")
]).then(()=>parcelRequire('48Eol'));

});

parcelRegister("eWwvy", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $49b80c0b2fd2c306$export$9c32b7bc3af8de64 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5liJC",
    name: "EditSpaceLogo",
    loader: async ()=>(await (parcelRequire("9DArD"))).EditSpaceLogo
});
module.exports["EditSpaceLogo"] = $49b80c0b2fd2c306$export$9c32b7bc3af8de64;

});

parcelRegister("9DArD", function(module, exports) {

let $704406b6573c39a2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $704406b6573c39a2$var$load("kyxdN").then(()=>parcelRequire('asonV'));

});

parcelRegister("ezLwY", function(module, exports) {
parcelRequire("cEgln");
var $3IK76 = parcelRequire("3IK76");


var $cpjd2 = parcelRequire("cpjd2");

const $a9c9343047c8f651$var$contexts = {};
const $a9c9343047c8f651$var$runSafely = (fn)=>{
    try {
        fn();
    } catch (e) {
        // TODO: find a real fix for this issue HOT-82965 | CONFCLOUD-58951
        console.error(e);
    }
};
const $a9c9343047c8f651$export$2cd8252107eb640b = ()=>{
    (0, $cpjd2.requireLegacyWRM)([
        'wrc!confluence-keyboard-shortcuts-batch'
    ], ()=>{
        $a9c9343047c8f651$var$runSafely(()=>{
            (0, $3IK76.bind)('register-contexts.keyboardshortcuts', (e, data)=>{
                const { enableContext: enableContext } = data.shortcutRegistry;
                Object.entries($a9c9343047c8f651$var$contexts).forEach(([context, enabled])=>{
                    if (enabled) enableContext(context);
                });
            });
            (0, $3IK76.trigger)('initialize.keyboardshortcuts');
        });
    }, ()=>{});
};
const $a9c9343047c8f651$export$e758fd0259c79269 = ()=>{
    // We need to disable all shortcuts and enable again
    // the ones still available as the currrent library doesn't expose a
    // method for removing just one context and we want to keep previous
    // added contexts alive
    $a9c9343047c8f651$var$runSafely(()=>{
        (0, $3IK76.trigger)('remove-bindings.keyboardshortcuts');
        (0, $3IK76.trigger)('initialize.keyboardshortcuts');
    });
};
const $a9c9343047c8f651$var$makeSetContext = (enable)=>(newContexts)=>{
        if (!Array.isArray(newContexts)) newContexts = [
            newContexts
        ];
        newContexts.forEach((context)=>{
            if ($a9c9343047c8f651$var$contexts[context] !== enable) {
                $a9c9343047c8f651$var$contexts[context] = enable;
                $a9c9343047c8f651$export$e758fd0259c79269();
            }
        });
    };
const $a9c9343047c8f651$export$2ca78a0e32b5ba4e = $a9c9343047c8f651$var$makeSetContext(true);
const $a9c9343047c8f651$export$48a00fd3a2cf40e0 = $a9c9343047c8f651$var$makeSetContext(false);
const $a9c9343047c8f651$export$4794d9b1949031cf = ()=>{
    $a9c9343047c8f651$var$runSafely(()=>{
        (0, $3IK76.trigger)('remove-bindings.keyboardshortcuts');
    });
};
module.exports["init"] = $a9c9343047c8f651$export$2cd8252107eb640b;
module.exports["enableContext"] = $a9c9343047c8f651$export$2ca78a0e32b5ba4e;
module.exports["disableContext"] = $a9c9343047c8f651$export$48a00fd3a2cf40e0;
module.exports["teardown"] = $a9c9343047c8f651$export$4794d9b1949031cf;

});

parcelRegister("cEgln", function(module, exports) {
$parcel$export(module.exports, "trigger", () => (parcelRequire("3IK76")).trigger);
$parcel$export(module.exports, "bind", () => (parcelRequire("3IK76")).bind);
$parcel$export(module.exports, "unbind", () => (parcelRequire("3IK76")).unbind);

var $3IK76 = parcelRequire("3IK76");


});

parcelRegister("3IK76", function(module, exports) {

var $1i7uI = parcelRequire("1i7uI");


var $jnN7b = parcelRequire("jnN7b");

function $2b59405ae3db7385$export$2385a24977818dd0(eventType, eventData, handler) {
    if (typeof handler === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($1i7uI)))).bind(eventType, eventData, handler);
    else return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($1i7uI)))).bind(eventType, eventData);
}
function $2b59405ae3db7385$export$433e98592e7124fd(eventType, handler) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($1i7uI)))).unbind(eventType, handler);
}
function $2b59405ae3db7385$export$e614dc9140f7ae71(eventType, extraParameters) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($1i7uI)))).trigger(eventType, extraParameters);
}
module.exports["bind"] = $2b59405ae3db7385$export$2385a24977818dd0;
module.exports["unbind"] = $2b59405ae3db7385$export$433e98592e7124fd;
module.exports["trigger"] = $2b59405ae3db7385$export$e614dc9140f7ae71;

});

parcelRegister("jnN7b", function(module, exports) {
module.exports = jQuery;

});

parcelRegister("49fir", function(module, exports) {

let $3053de381b7dd0dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3053de381b7dd0dd$var$load("lgm1i").then(()=>parcelRequire('04Nru'));

});

parcelRegister("jzEl8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $9HkI0 = parcelRequire("9HkI0");

const $6cbcb1ce2cb81a03$var$REPLACED_MARKER = 'data-replaced';
const $6cbcb1ce2cb81a03$var$CLONE_MARKER = 'data-clone';
function $6cbcb1ce2cb81a03$var$getLegacyElements(selectors, rootNode = window.document) {
    if (!rootNode) return [];
    return Array.from(rootNode.querySelectorAll(selectors.join(',')));
}
function $6cbcb1ce2cb81a03$var$getDomElementAttrsMap(domElement) {
    if (!domElement.hasAttributes()) return {};
    return Object.values(domElement.attributes).reduce((acc, attr)=>{
        acc[attr.name] = attr.value;
        return acc;
    }, {});
}
const $6cbcb1ce2cb81a03$export$a1d3010d20ec2131 = /*#__PURE__*/ (0, $cozmU.memo)(function LegacyDOMBridge({ selectors: selectors, attempts: attempts = 1, retryDelay: retryDelay = 50, rootNode: rootNode, portalNode: portalNode, replacePlaceholderWith: replacePlaceholderWith, deleteExistingContent: deleteExistingContent = true }) {
    const [portals, setPortals] = (0, $cozmU.useState)([]);
    const workerInProgressRef = (0, $cozmU.useRef)(false);
    const portalsRef = (0, $cozmU.useRef)([]);
    const replaceDOMElementsWithPortal = (0, $cozmU.useCallback)((attemptsLeft)=>{
        workerInProgressRef.current = true;
        $6cbcb1ce2cb81a03$var$getLegacyElements(selectors, rootNode).forEach((node)=>{
            const currentNodeAttrs = $6cbcb1ce2cb81a03$var$getDomElementAttrsMap(node);
            if (currentNodeAttrs[$6cbcb1ce2cb81a03$var$REPLACED_MARKER] || currentNodeAttrs[$6cbcb1ce2cb81a03$var$CLONE_MARKER]) return; // do not clone clones or already cloned nodes
            // @ts-expect-error FIXME: `true` here probably needs to be replaced with `"true"`
            node.setAttribute($6cbcb1ce2cb81a03$var$REPLACED_MARKER, true);
            // @ts-expect-error FIXME: `true` here probably needs to be replaced with `"true"`
            currentNodeAttrs[$6cbcb1ce2cb81a03$var$CLONE_MARKER] = true;
            currentNodeAttrs['key'] = currentNodeAttrs.id || (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
            let targetNode = node;
            if (replacePlaceholderWith) {
                targetNode = window.document.createElement(replacePlaceholderWith.elementName);
                const attributes = replacePlaceholderWith.attributes || {};
                for(const attr in attributes)targetNode.setAttribute(attr, attributes[attr]);
                node.parentNode.replaceChild(targetNode, node);
            }
            if (deleteExistingContent) while(targetNode.firstChild)targetNode.removeChild(targetNode.firstChild);
            if (portalNode) {
                const reactEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(portalNode, currentNodeAttrs);
                portalsRef.current.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(reactEl, targetNode));
            }
        });
        const remaining = attemptsLeft - 1;
        setPortals([
            ...portalsRef.current
        ]);
        if (remaining > 0) window.setTimeout(()=>{
            replaceDOMElementsWithPortal(remaining);
        }, retryDelay);
        else workerInProgressRef.current = false;
    }, [
        selectors,
        rootNode,
        portalNode,
        replacePlaceholderWith,
        deleteExistingContent,
        retryDelay
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (attempts > 0 && !workerInProgressRef.current) {
            const timerId = setTimeout(()=>{
                replaceDOMElementsWithPortal(attempts);
            }, 0);
            return ()=>clearTimeout(timerId);
        }
    }, [
        attempts,
        replaceDOMElementsWithPortal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, portals);
});
module.exports["LegacyDOMBridge"] = $6cbcb1ce2cb81a03$export$a1d3010d20ec2131;

});

parcelRegister("jBEZO", function(module, exports) {

let $e46145fd30c70ba5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e46145fd30c70ba5$var$load("6wr18"),
    $e46145fd30c70ba5$var$load("j06N4"),
    $e46145fd30c70ba5$var$load("ffEVr"),
    $e46145fd30c70ba5$var$load("Wowvf"),
    $e46145fd30c70ba5$var$load("hhss7"),
    $e46145fd30c70ba5$var$load("lwfE5")
]).then(()=>parcelRequire('MkVVm'));

});

parcelRegister("5WXBa", function(module, exports) {

let $011e340671e6397b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $011e340671e6397b$var$load("6wr18"),
    $011e340671e6397b$var$load("ffEVr"),
    $011e340671e6397b$var$load("Wowvf"),
    $011e340671e6397b$var$load("hhss7"),
    $011e340671e6397b$var$load("d7sp9")
]).then(()=>parcelRequire('4Au5p'));

});

parcelRegister("lJZup", function(module, exports) {

let $fd3d7f76a22341ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fd3d7f76a22341ef$var$load("hhss7"),
    $fd3d7f76a22341ef$var$load("ei0Jg")
]).then(()=>parcelRequire('esrJ1'));

});

parcelRegister("10Uyw", function(module, exports) {

let $0bd1a9507bf4aec8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0bd1a9507bf4aec8$var$load("hhf8b").then(()=>parcelRequire('cDa2P'));

});

parcelRegister("eiv96", function(module, exports) {

let $a68ae80c34e9ba5a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a68ae80c34e9ba5a$var$load("7wlV6"),
    $a68ae80c34e9ba5a$var$load("82QsP"),
    $a68ae80c34e9ba5a$var$load("an2zh")
]).then(()=>parcelRequire('3Fqft'));

});

parcelRegister("e0okQ", function(module, exports) {

let $a323f13e49572479$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a323f13e49572479$var$load("7wlV6"),
    $a323f13e49572479$var$load("82QsP"),
    $a323f13e49572479$var$load("gJRFC")
]).then(()=>parcelRequire('bQl5d'));

});

parcelRegister("14QAi", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $jH9cM = parcelRequire("jH9cM");


var $hBkCm = parcelRequire("hBkCm");

var $flE5X = parcelRequire("flE5X");

const $1ce5a19013c572e5$export$529433b0a9e66822 = (url, isFedrampEnv)=>{
    const isFedrampEnvironment = isFedrampEnv ?? (0, $jH9cM.isFedRamp)();
    if (isFedrampEnvironment) {
        // Transform help-aggregator paths for FedRAMP environment
        // /gateway/api/help-content/v2/* -> /gateway/api/ha/v2/*
        // Stargate handles routing, so return relative path without domain
        if (url.startsWith('/gateway/api/help-content/v2/')) {
            const pathAfterV2 = url.replace('/gateway/api/help-content/v2', '');
            return `/gateway/api/ha/v2${pathAfterV2}`;
        }
        // For non-help-aggregator paths in FedRAMP, return as-is (relative)
        return url;
    }
    // For non-FedRAMP environments, use relative URLs (current behavior)
    return url;
};
// ANALYTICS PROPERTIES
const $1ce5a19013c572e5$var$SPACE_OVERVIEW = 'spaceSettings/overview';
const $1ce5a19013c572e5$var$SPACE_PERMISSIONS = 'spaceSettings/permissions';
const $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS = 'spaceSettings/contentTools';
const $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL = 'spaceSettings/lookAndFeel';
const $1ce5a19013c572e5$var$SPACE_INTEGRATIONS = 'spaceSettings/Integrations';
// ROUTE GROUPS
const $1ce5a19013c572e5$var$SPACE_SETTINGS = 'space-settings';
const $1ce5a19013c572e5$export$244e5242c65921be = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice#13.-Additional-Disclosures-for-California-Residents';
const $1ce5a19013c572e5$export$ab8f8977c5e363cb = 'https://www.atlassian.com/legal/privacy-policy#additional-disclosures-for-ca-residents';
const $1ce5a19013c572e5$export$86f8e0fbd7845b32 = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice';
const $1ce5a19013c572e5$export$87259143062a27ea = 'https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers';
const $1ce5a19013c572e5$export$108231643dc5e01e = [
    'Online Help',
    'Get the mobile app',
    'Feed Builder',
    'Keyboard Shortcuts',
    'Site Status',
    "What\u2019s new",
    'About Confluence'
];
const $1ce5a19013c572e5$export$40e045b7d0d057fd = (route)=>{
    // get what route we're on by switching based on
    // the regex evaluating to true
    switch(true){
        /**
		 * SPACE SETTINGS - OVERVIEW
		 */ case /viewspacesummary/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-details',
                articleId: '2ngx6W7OSkTdvFP6m1jdYC',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'spaceDetailsScreen'
            };
        case /archivespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /archiveSpace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /editFeatures/.test(route):
            return {
                routeName: 'edit-sidebar',
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                articleId: '6ivofSJlfSXa9IASo00kvA',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'sidebarConfigurationScreen'
            };
        case /removespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'delete-space',
                articleId: '7edCGN0nkqsvUd9s3AzEq8',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'deleteSpaceScreen'
            };
        /**
		 * SPACE SETTINGS - PERMISSIONS
		 */ case /spaces\/.*\/settings\/permissions\/\d*/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /spacepermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /addonpermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'addOnScreen'
            };
        case /listpermissionpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'page-restrictions',
                articleId: '7f9j14trnF75aeuihHAoLp',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'restrictedPagesScreen'
            };
        case /reorderpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'reorder-pages',
                articleId: '5faOvjH2hAw2CpZY3tC3ej',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'reorderPagesScreen'
            };
        case /listorphanedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'orphaned-pages',
                articleId: '1mxG2f1dvIifiDqKrkvy98',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'orphanedPagesScreen'
            };
        case /listundefinedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined-pages',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'undefinedPagesScreen'
            };
        case /listattachmentsforspace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'attachments',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'attachmentsScreen'
            };
        case /viewtrash/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'trash',
                articleId: '6NL5cRC6aV7k9ucd2yEZzZ',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'trashScreen'
            };
        case /exportspacewelcome/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'export-space',
                articleId: '6RcXthpHKQasH09gERDkE8',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'exportScreen'
            };
        case /listrssfeeds/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'rss-feed',
                articleId: '6TyTkhaowcNTwvq9V0rt10',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'rssFeedsScreen'
            };
        /**
		 * SPACE SETTINGS - LOOK AND FEEL
		 */ case /spaces\/choosetheme/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'themes',
                articleId: '3Owkyfl2mshKQQ2mECCV8q',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'themesScreen'
            };
        case /custompagecontent/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'header-and-footer',
                articleId: '2i2NAHbTjkWeoprrdWlNX',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'headerAndFooterScreen'
            };
        case /viewpdfconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfConfigScreen'
            };
        case /viewpdflayoutconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfLayoutScreen'
            };
        case /viewpdfstyleconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfStylesheetScreen'
            };
        /**
		 * SPACE SETTINGS - INTEGRATIONS
		 */ case /listentitylinks/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_INTEGRATIONS,
                screen: 'applicationLinksScreen'
            };
        /**
		 * CONNECT ADDONS
		 */ case /analytics\/permissions/.test(route):
            return {
                routeGroup: 'site-settings',
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /atlassian-connect\/space-tools-tab.action/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'analyticsPermissionsScreen'
            };
        /**
		 * CONTENT TYPE VIEW PAGES
		 */ case /spaces\/.*\/pages\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-page',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/whiteboard\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-whiteboard',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/database\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-database',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/embed\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-embed',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/calendars/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-calendars',
                articleId: '85KAXe75f9VdMibJa5FHz',
                section: 'notTracked',
                screen: 'notTracked'
            };
        /**
		 * EVERYTHING ELSE
		 */ default:
            return {
                routeGroup: 'undefined',
                articleId: '',
                section: 'notTracked',
                routeName: 'undefined',
                screen: 'notTracked'
            };
    }
};
const $1ce5a19013c572e5$export$c28bcc688252a1b6 = (error)=>{
    return [
        'algolia',
        'unreachable hosts'
    ].some((err)=>error.message.toLowerCase().includes(err)) || error instanceof (0, $flE5X.NoNetworkError) || error instanceof (0, $hBkCm.BadStatusError) && error.response.status >= 500;
};
module.exports["getFedSupportGatewayURL"] = $1ce5a19013c572e5$export$529433b0a9e66822;
module.exports["INTERNAL_NOTICE_AT_COLLECTION_LINK"] = $1ce5a19013c572e5$export$244e5242c65921be;
module.exports["EXTERNAL_NOTICE_AT_COLLECTION_LINK"] = $1ce5a19013c572e5$export$ab8f8977c5e363cb;
module.exports["INTERNAL_PRIVACY_POLICY_LINK"] = $1ce5a19013c572e5$export$86f8e0fbd7845b32;
module.exports["EXTERNAL_PRIVACY_POLICY_LINK"] = $1ce5a19013c572e5$export$87259143062a27ea;
module.exports["FILTERED_MENU_ITEMS"] = $1ce5a19013c572e5$export$108231643dc5e01e;
module.exports["getRouteData"] = $1ce5a19013c572e5$export$40e045b7d0d057fd;
module.exports["isSearchProviderUnreachableError"] = $1ce5a19013c572e5$export$c28bcc688252a1b6;

});

parcelRegister("3WPwA", function(module, exports) {

let $2dfec1900ec4c9f0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2dfec1900ec4c9f0$var$load("6wr18"),
    $2dfec1900ec4c9f0$var$load("ffEVr"),
    $2dfec1900ec4c9f0$var$load("feGHs"),
    $2dfec1900ec4c9f0$var$load("8NwgG")
]).then(()=>parcelRequire('a3BLy'));

});

$parcel$global.rwr("3pblT", () => { 
var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $B8b0t = parcelRequire("B8b0t");


var $hp2SH = parcelRequire("hp2SH");


var $iC5L0 = parcelRequire("iC5L0");


var $aXEzU = parcelRequire("aXEzU");





var $3WLLD = parcelRequire("3WLLD");


var $bj5fB = parcelRequire("bj5fB");





var $7J5Uc = parcelRequire("7J5Uc");

const $14d55bbfca2abbc5$export$7a88623f52f1b79 = (initialTheme)=>{
    const [{ isInitialized: isInitialized }, { initializeTheme: initializeTheme }] = (0, $7J5Uc.useThemingState)();
    (0, $cozmU.useEffect)(()=>{
        initializeTheme(initialTheme);
    // Only execute upon initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return isInitialized;
};


const $e6baa9171970034d$export$11eb671888ed6e7d = ({ children: children })=>{
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const initialTheme = isMobileApp ? (0, $3WLLD.mobileAppTheme) : undefined;
    const isInitialized = (0, $14d55bbfca2abbc5$export$7a88623f52f1b79)(initialTheme);
    if (!isInitialized) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};



var $7zgzO = parcelRequire("7zgzO");


var $awd1Q = parcelRequire("awd1Q");


var $9j59h = parcelRequire("9j59h");


var $xwvlW = parcelRequire("xwvlW");


var $8PKGr = parcelRequire("8PKGr");


var $17wUi = parcelRequire("17wUi");


var $gnYQc = parcelRequire("gnYQc");


var $2DVQX = parcelRequire("2DVQX");


var $7ZzSP = parcelRequire("7ZzSP");


var $7LuKf = parcelRequire("7LuKf");





var $1i7uI = parcelRequire("1i7uI");


var $6b4nE = parcelRequire("6b4nE");


var $fRQ3t = parcelRequire("fRQ3t");


var $ge2sX = parcelRequire("ge2sX");


var $f7i8j = parcelRequire("f7i8j");


var $cryCi = parcelRequire("cryCi");


var $dBmJE = parcelRequire("dBmJE");








var $bEYte = parcelRequire("bEYte");


var $kNIYN = parcelRequire("kNIYN");


var $lonEO = parcelRequire("lonEO");


var $iJELi = parcelRequire("iJELi");


var $d5ap9 = parcelRequire("d5ap9");


var $hmRc4 = parcelRequire("hmRc4");


var $fcF01 = parcelRequire("fcF01");


var $iJiK8 = parcelRequire("iJiK8");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $25MM7 = parcelRequire("25MM7");





var $jVK0t = parcelRequire("jVK0t");


var $64KID = parcelRequire("64KID");


var $kZDrw = parcelRequire("kZDrw");


var $8n9tL = parcelRequire("8n9tL");


var $1ytiN = parcelRequire("1ytiN");


var $a5txT = parcelRequire("a5txT");


var $97W74 = parcelRequire("97W74");

class $7db816b9e13721ff$export$2e2bcd8739ae039 extends (0, $cozmU.Component) {
    render() {
        const { store: store } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Provider), {
            inject: [
                (0, $a5txT.getStandalonePageTreeStateUpdater)()
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lonEO.GraphqlProvider), {
            client: (0, $hp2SH.getApolloClient)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bEYte.Provider), {
            store: store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1ytiN.SPAViewContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1kHsc.ExperienceTrackerContext).Provider, {
            value: (0, $fGzMp.getExperienceTracker)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jVK0t.I18nProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5ap9.ConfluenceAnalyticsListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kZDrw.NavdexListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97W74.EngagementProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dBmJE.ConnectedRouter), {
            history: this.browserHistory,
            context: (0, $bEYte.ReactReduxContext)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fcF01.UpFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $25MM7.Flags), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJELi.ConnectSupport), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8n9tL.RouteManager), {
            namedRoutes: (0, $64KID.namedRoutes)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJiK8.Dialogs), null), this.props.children))))))))))));
    }
    constructor(...args){
        super(...args);
        this.browserHistory = (0, $hmRc4.getBrowserHistory)();
    }
}
$7db816b9e13721ff$export$2e2bcd8739ae039.propTypes = {
    /**
   * Global store
   */ store: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object.isRequired,
    /**
   * Children Component
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).any,
    /**
   * Indicates if the component is rendered as Root
   */ renderAsRoot: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};



var $3Tw8v = parcelRequire("3Tw8v");


var $9F7Qb = parcelRequire("9F7Qb");

const $d4f95b5cede9219f$var$store = (0, $3Tw8v.default)({
    isServerRenderedPage: true
});
(0, $9F7Qb.subscribe)($d4f95b5cede9219f$var$store);
/**
 * Method for rendering React/Redux component
 * Usage:
 * import renderComponent from './renderComponentIntoDOM';
 * renderComponent(<YourComponent />, 'your-component-section-id');
 * OR renderComponent(<YourComponent />, DOMComponent);
 *
 * @param children
 * @param container DOM node or id string
 */ const $d4f95b5cede9219f$var$renderComponentIntoDOM = (children, container, renderAsRoot = false)=>{
    if (typeof container === 'string') container = (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).document.getElementById(container);
    const Component = ({ sessionData: sessionData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7i8j.SessionDataContext).Provider, {
            value: sessionData
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cryCi.Provider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7db816b9e13721ff$export$2e2bcd8739ae039), {
            store: $d4f95b5cede9219f$var$store,
            renderAsRoot: renderAsRoot
        }, children)));
    Component.propTypes = {
        sessionData: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object.isRequired
    };
    (0, $ge2sX.getSessionData)().then((sessionData)=>{
        const concurrentComponentWrapper = (0, $fRQ3t.createRoot)(container);
        concurrentComponentWrapper.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            sessionData: sessionData
        }));
    });
};
var $d4f95b5cede9219f$export$2e2bcd8739ae039 = $d4f95b5cede9219f$var$renderComponentIntoDOM;



var $7RVQB = parcelRequire("7RVQB");




/**
 * These helper functions should be used to minimize the impact the standalone sidebar causes to the ui (jump, flip, flash, jank);
 */ const $8bee1fe38b9eef04$var$mainSectionsSelectors = [
    '#main',
    '#admin-content',
    '#custom-content-container',
    '.ap-servlet-placeholder'
];
const $8bee1fe38b9eef04$export$ed04e7f6ba662aee = ()=>{
    const head = (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).document.head || (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).document.querySelector('head');
    const style = (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).document.createElement('style');
    const css = `${$8bee1fe38b9eef04$var$mainSectionsSelectors.join(',')} { opacity: 0 };`;
    style.type = 'text/css';
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild((0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).document.createTextNode(css));
    if (head) head.appendChild(style);
};
const $8bee1fe38b9eef04$export$4011f4c5a8044281 = (runs = 0)=>{
    const mainContainers = $8bee1fe38b9eef04$var$mainSectionsSelectors.map((selector)=>(0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).document.querySelector(selector)).filter((ele)=>ele !== null);
    if (mainContainers.length) mainContainers.forEach((container)=>{
        if (container) {
            container.style.transition = 'opacity .15s ease-in';
            container.style.opacity = '1';
        }
    });
    else // accounting for any race condition that could delay the parsing of the content
    if (runs < 5) {
        console.warn('Legacy pages: trying to fix jank behaviour on legacy pages but content container is not found yet');
        setTimeout(()=>$8bee1fe38b9eef04$export$4011f4c5a8044281(runs + 1), 100);
    } else console.error('Legacy pages: content container was not found');
};






var $iyEDi = parcelRequire("iyEDi");


var $gnnzK = parcelRequire("gnnzK");


var $1NBp8 = parcelRequire("1NBp8");

/* StandaloneConfluenceNavigation.js generated by @compiled/babel-plugin v2.0.0 */ 



var $hekY6 = parcelRequire("hekY6");





var $eXODy = parcelRequire("eXODy");


var $iV00x = parcelRequire("iV00x");


var $hpWmZ = parcelRequire("hpWmZ");


var $NAPtM = parcelRequire("NAPtM");


var $3u0dr = parcelRequire("3u0dr");





var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $bQm3c = parcelRequire("bQm3c");











var $kSwu1 = parcelRequire("kSwu1");


var $30qWc = parcelRequire("30qWc");





var $gqqjz = parcelRequire("gqqjz");








var $b1HmN = parcelRequire("b1HmN");

/**
 * @generated SignedSource<<c965c2c8b5b8a962a6d43a8b0b796cad>>
 * @relayHash 737a60122b0a1fbdaa4709876ac5fba5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f28965208d5e300780b488da945a8c46ef96b505c2ea6e19d9e29b5a2290d1ea
const $d6dcaac643994a17$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentRestrictionsPageResponse",
            "kind": "LinkedField",
            "name": "clearRestrictionsForFree",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "restrictionsHash"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ChangeEditionClearRestrictionsForFreeMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ChangeEditionClearRestrictionsForFreeMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "737a60122b0a1fbdaa4709876ac5fba5",
            "id": "f28965208d5e300780b488da945a8c46ef96b505c2ea6e19d9e29b5a2290d1ea",
            "metadata": {},
            "name": "ChangeEditionClearRestrictionsForFreeMutation",
            "operationKind": "mutation",
            "text": "mutation ChangeEditionClearRestrictionsForFreeMutation($contentId:ID!){clearRestrictionsForFree(contentId:$contentId){restrictionsHash}}"
        }
    };
}();
$d6dcaac643994a17$var$node.hash = "a6f31038cfbb195a7ec707513d6d3235";
var $d6dcaac643994a17$export$2e2bcd8739ae039 = $d6dcaac643994a17$var$node;


const $c9e67d6bb8fbd3cb$export$c8d7574a93f4b7d4 = (0, $d6dcaac643994a17$export$2e2bcd8739ae039);


const $e5314625536bb69f$export$8a37b2ec23f0faea = 'confluence-change-edition-remove-restrictions-button';
const $e5314625536bb69f$export$9f92e67dea336ca7 = 'confluence-change-edition-notification-dialog';
const $e5314625536bb69f$var$i18n = (0, $kSwu1.defineMessages)({
    removeRestrictionButton: {
        id: "change-edition.notification.dialog.general.button.remove-restrictions",
        defaultMessage: "Remove restrictions"
    },
    removeRestrictionTitle: {
        id: "change-edition.notification.dialog.general.title.remove-restrictions-2",
        defaultMessage: "Remove restrictions?"
    },
    removeRestrictionTextSpaceLevel: {
        id: "change-edition.notification.dialog.space.text.remove-restrictions",
        defaultMessage: "You\u2019re on the free plan, so you can only <b>remove all restrictions</b> from <b>{contentTitle}</b>. <b>This can\u2019t be undone.</b> You won\u2019t be able to reset the restrictions later."
    },
    removeRestrictionConfirmationSuccessTitle: {
        id: "change-edition.notification.dialog.confirmation.success.title",
        defaultMessage: "Restrictions removed"
    },
    removeRestrictionConfirmationSuccessDesc: {
        id: "change-edition.notification.dialog.confirmation.success.desc",
        defaultMessage: "Anyone who\u2019s logged in can now view and edit {contentTitle}."
    },
    removeRestrictionConfirmationFailedTitle: {
        id: "change-edition.notification.dialog.confirmation.failed.title",
        defaultMessage: "Page restrictions not removed"
    },
    removeRestrictionConfirmationFailedDesc: {
        id: "change-edition.notification.dialog.confirmation.failed.desc",
        defaultMessage: "We couldn\u2019t remove restrictions from {contentTitle}. Try again."
    }
});
const $e5314625536bb69f$var$DEFAULT_COMPONENT_STATE = {
    isNotificationOpen: false,
    isMutationInProcess: false,
    contentId: null,
    contentTitle: null
};
//TODO: remove dep on shared i18n.
const $e5314625536bb69f$var$changeEditionPageRestrictionsLegacyCoordinatorI18n = (0, $kSwu1.defineMessages)({
    // Notification Dialog --------------------
    cancelButton: {
        id: "change-edition.general.button.cancel",
        defaultMessage: "Cancel"
    }
});
class $e5314625536bb69f$var$ChangeEditionPageRestrictionsLegacyCoordinatorComponent extends (0, $cozmU.PureComponent) {
    componentDidMount() {
        Array.prototype.forEach.call(this.allRemoveRestrictionsElements, (el)=>{
            el.addEventListener('click', this.openNotificationDialog);
        });
    }
    componentWillUnmount() {
        Array.prototype.forEach.call(this.allRemoveRestrictionsElements, (el)=>{
            el.removeEventListener('click', this.openNotificationDialog);
        });
    }
    render() {
        const { intl: intl } = this.props;
        const { isNotificationOpen: isNotificationOpen, isMutationInProcess: isMutationInProcess, contentTitle: contentTitle, contentId: contentId } = this.state;
        if (!this.placeholderEl) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ location: location, matchRoute: matchRoute })=>{
            const route = matchRoute(location.pathname);
            // Skip rendering for other then "Space Setting / Restricted Page" page
            if (!route || route.name != (0, $1NBp8.SPACE_RESTRICTED_PAGES).name) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $30qWc.MutationInterop), {
                    mutation: (0, $c9e67d6bb8fbd3cb$export$c8d7574a93f4b7d4),
                    variables: {
                        contentId: contentId
                    },
                    onCompleted: this.handleMutationComplete(flags),
                    onError: this.handleMutationError(flags)
                }, (clearRestrictionsForFreeMutation)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b1HmN.LoadableChangeEditionNotificationDialog), {
                        isOpen: isNotificationOpen,
                        isProcessing: isMutationInProcess,
                        cancelAction: {
                            text: intl.formatMessage($e5314625536bb69f$var$changeEditionPageRestrictionsLegacyCoordinatorI18n.cancelButton),
                            onClick: this.closeNotificationDialog
                        },
                        applyAction: {
                            text: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionButton),
                            onClick: this.applyChanges(clearRestrictionsForFreeMutation)
                        },
                        heading: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionTitle),
                        source: "individualSpaceRestrictedPages",
                        grandfathered: true
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                        ...$e5314625536bb69f$var$i18n.removeRestrictionTextSpaceLevel,
                        values: {
                            contentTitle: contentTitle,
                            b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
                        }
                    })))), this.placeholderEl);
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            ...$e5314625536bb69f$var$DEFAULT_COMPONENT_STATE
        };
        this.allRemoveRestrictionsElements = window.document.getElementsByClassName($e5314625536bb69f$export$8a37b2ec23f0faea) || [];
        this.placeholderEl = window.document.getElementById($e5314625536bb69f$export$9f92e67dea336ca7);
        this.openNotificationDialog = (event)=>{
            this.setState({
                isNotificationOpen: true,
                contentId: event.target.getAttribute('data-page-id'),
                contentTitle: event.target.getAttribute('data-page-title')
            });
        };
        this.closeNotificationDialog = ()=>{
            this.setState($e5314625536bb69f$var$DEFAULT_COMPONENT_STATE);
        };
        this.applyChanges = (mutationFunction)=>()=>{
                this.setState({
                    isMutationInProcess: true
                });
                mutationFunction();
            };
        this.handleMutationComplete = (flags)=>()=>{
                const { intl: intl } = this.props;
                const { contentTitle: contentTitle } = this.state;
                flags.showSuccessFlag({
                    title: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationSuccessTitle),
                    description: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationSuccessDesc, {
                        contentTitle: contentTitle
                    })
                });
                this.closeNotificationDialog();
                window.setTimeout(()=>{
                    // refresh the page to see the changes
                    window.location.reload();
                }, 500);
            };
        this.handleMutationError = (flags)=>()=>{
                const { intl: intl } = this.props;
                const { contentTitle: contentTitle } = this.state;
                flags.showErrorFlag({
                    title: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationFailedTitle),
                    description: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationFailedDesc, {
                        contentTitle: contentTitle
                    })
                });
                this.closeNotificationDialog();
            };
    }
}
$e5314625536bb69f$var$ChangeEditionPageRestrictionsLegacyCoordinatorComponent.propTypes = {
    intl: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object
};
const $e5314625536bb69f$export$5b44234181f42094 = (0, $kSwu1.injectIntl)($e5314625536bb69f$var$ChangeEditionPageRestrictionsLegacyCoordinatorComponent);


















var $bDgLe = parcelRequire("bDgLe");











var $4WmbV = parcelRequire("4WmbV");

const $4c2daaa3bc0c282d$var$i18n = (0, $kSwu1.defineMessages)({
    siteAdminAuditLogsTitle: {
        id: "change-edition.section.message.site-admin.audit-logs.title",
        defaultMessage: "Upgrade for Audit logs"
    },
    nonSiteAdminAuditLogsTitle: {
        id: "change-edition.section.message.non-site-admin.audit-logs.title",
        defaultMessage: "Audit logs are only available on paid plans"
    },
    siteAdminAuditLogsBody: {
        id: "change-edition.section.message.site-admin-audit-logs.body",
        defaultMessage: "You\u2019re on the free plan, so you can\u2019t view and track changes made across your site in the audit logs. To access the audit logs, upgrade your plan."
    },
    nonSiteAdminAuditLogsBody: {
        id: "change-edition.section.message.non-site-admin-audit-logs.body",
        defaultMessage: "You\u2019re on the free plan, so you can\u2019t view and track changes made across your site in the audit logs."
    }
});
const $4c2daaa3bc0c282d$export$cb2ba78fe55aff74 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(9);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const title = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsTitle : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsTitle;
    const body = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsBody : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsBody;
    let t0;
    if ($[0] !== formatMessage || $[1] !== title) {
        t0 = formatMessage(title);
        $[0] = formatMessage;
        $[1] = title;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== body || $[4] !== formatMessage) {
        t1 = formatMessage(body);
        $[3] = body;
        $[4] = formatMessage;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== t0 || $[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
            title: t0,
            body: t1,
            source: "auditLogs"
        });
        $[6] = t0;
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const title = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsTitle : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsTitle;
    const body = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsBody : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsBody;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        title: formatMessage(title),
        body: formatMessage(body),
        source: "auditLogs"
    });
};


















var $f7Bnv = parcelRequire("f7Bnv");




const $ee74963fbde2c4ed$var$i18n = (0, $kSwu1.defineMessages)({
    siteAdminContentRestrictionsTitle: {
        id: "change-edition.section.message.site-admin.content-restrictions.title",
        defaultMessage: "Upgrade for content-level restrictions"
    },
    nonSiteAdminContentRestrictionsTitle: {
        id: "change-edition.section.message.non-site-admin.content-restrictions.title",
        defaultMessage: "Content-level restrictions are only available on paid plans"
    },
    spaceRestrictedPagesText: {
        id: "change-edition.section.message.space-restricted-pages.text",
        defaultMessage: "You\u2019re on the free plan, so you can only remove all restrictions from content by clicking the lock icon below. To set restrictions, upgrade your plan."
    },
    nonSiteAdminGrandfatheredRestrictedPagesBody: {
        id: "change-edition.section.message.non-admin.grandfathered.space-restricted-pages.body",
        defaultMessage: "You\u2019re on the free plan, so you can only remove all restrictions from content by clicking the lock icon below."
    },
    siteAdminRestrictedPagesBody: {
        id: "change-edition.section.message.site-admin.space-restricted-pages.body",
        defaultMessage: "You\u2019re on the free plan, so anyone who\u2019s logged in can view and edit everything. To set restrictions, upgrade your plan."
    },
    nonSiteAdminRestrictedPagesBody: {
        id: "change-edition.section.message.non-admin.space-restricted-pages.body",
        defaultMessage: "You\u2019re on the free plan, so anyone who\u2019s logged in can view and edit everything."
    }
});
function $ee74963fbde2c4ed$var$getBody(isSiteAdmin, grandfathered) {
    if (grandfathered) {
        if (isSiteAdmin) return $ee74963fbde2c4ed$var$i18n.spaceRestrictedPagesText;
        else return $ee74963fbde2c4ed$var$i18n.nonSiteAdminGrandfatheredRestrictedPagesBody;
    } else {
        if (isSiteAdmin) return $ee74963fbde2c4ed$var$i18n.siteAdminRestrictedPagesBody;
        else return $ee74963fbde2c4ed$var$i18n.nonSiteAdminRestrictedPagesBody;
    }
}
const $ee74963fbde2c4ed$var$ChangeEditionSectionMessageSpaceContentComponent = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { grandfathered: grandfathered, isSiteAdmin: isSiteAdmin } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let T0;
    let t1;
    let t2;
    if ($[0] !== grandfathered || $[1] !== intl || $[2] !== isSiteAdmin) {
        const bodyText = $ee74963fbde2c4ed$var$getBody(isSiteAdmin, grandfathered);
        const title = isSiteAdmin ? $ee74963fbde2c4ed$var$i18n.siteAdminContentRestrictionsTitle : $ee74963fbde2c4ed$var$i18n.nonSiteAdminContentRestrictionsTitle;
        T0 = (0, $4WmbV.ChangeEditionSectionMessage);
        if ($[6] !== intl || $[7] !== title) {
            t1 = intl.formatMessage(title);
            $[6] = intl;
            $[7] = title;
            $[8] = t1;
        } else t1 = $[8];
        t2 = intl.formatMessage(bodyText);
        $[0] = grandfathered;
        $[1] = intl;
        $[2] = isSiteAdmin;
        $[3] = T0;
        $[4] = t1;
        $[5] = t2;
    } else {
        T0 = $[3];
        t1 = $[4];
        t2 = $[5];
    }
    let t3;
    if ($[9] !== T0 || $[10] !== t1 || $[11] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            title: t1,
            body: t2,
            source: "individualSpaceRestrictedPages"
        });
        $[9] = T0;
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
} : ({ grandfathered: grandfathered, isSiteAdmin: isSiteAdmin })=>{
    const intl = (0, $kSwu1.useIntl)();
    const bodyText = $ee74963fbde2c4ed$var$getBody(isSiteAdmin, grandfathered);
    const title = isSiteAdmin ? $ee74963fbde2c4ed$var$i18n.siteAdminContentRestrictionsTitle : $ee74963fbde2c4ed$var$i18n.nonSiteAdminContentRestrictionsTitle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        title: intl.formatMessage(title),
        body: intl.formatMessage(bodyText),
        source: "individualSpaceRestrictedPages"
    });
};
$ee74963fbde2c4ed$var$ChangeEditionSectionMessageSpaceContentComponent.propTypes = {
    grandfathered: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool.isRequired,
    isSiteAdmin: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool.isRequired
};
const $ee74963fbde2c4ed$export$51350d82d36f7e43 = (0, $f7Bnv.withIsSiteAdmin)($ee74963fbde2c4ed$var$ChangeEditionSectionMessageSpaceContentComponent);


const $63cbc74b40cb8d33$export$4a53029580aac53e = 'confluence-change-edition-section-message';
class $63cbc74b40cb8d33$export$b9f1eac8c818cdb0 extends (0, $cozmU.Component) {
    isSectionMessageNeeded(routeName) {
        return routeName && Boolean(this.ROUTE_NAME2COMPONENT[routeName.name]);
    }
    getComponentParams(routeName) {
        if (routeName === (0, $1NBp8.SPACE_RESTRICTED_PAGES).name) return {
            grandfathered: this.el.getAttribute('data-grandfathered') === 'true'
        };
        return {};
    }
    render() {
        if (!this.el) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ location: location, matchRoute: matchRoute })=>{
            const routeName = matchRoute(location.pathname + location.search);
            if (!this.isSectionMessageNeeded(routeName)) return null;
            const ChangEditionComponent = this.ROUTE_NAME2COMPONENT[routeName.name];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ChangEditionComponent, this.getComponentParams(routeName.name)), this.el);
        });
    }
    constructor(...args){
        super(...args);
        this.el = window.document.getElementById($63cbc74b40cb8d33$export$4a53029580aac53e);
        this.ROUTE_NAME2COMPONENT = {
            [(0, $1NBp8.SPACE_RESTRICTED_PAGES).name]: (0, $ee74963fbde2c4ed$export$51350d82d36f7e43),
            [(0, $1NBp8.ADMIN_AUDIT_LOG).name]: (0, $4c2daaa3bc0c282d$export$cb2ba78fe55aff74)
        };
    }
}


const $f60f9bb0af41c642$export$ddc928ad192d2b94 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $bQm3c.useSessionData)().edition === "FREE" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $63cbc74b40cb8d33$export$b9f1eac8c818cdb0), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e5314625536bb69f$export$5b44234181f42094), null))) : null;
} : ()=>(0, $bQm3c.useSessionData)().edition === 'FREE' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $63cbc74b40cb8d33$export$b9f1eac8c818cdb0), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e5314625536bb69f$export$5b44234181f42094), null))) : null;






var $4PPzL = parcelRequire("4PPzL");


var $04e9M = parcelRequire("04e9M");


var $56QzY = parcelRequire("56QzY");


var $aeSHO = parcelRequire("aeSHO");


var $iJ8K8 = parcelRequire("iJ8K8");


var $lFjPc = parcelRequire("lFjPc");


var $5ZPtT = parcelRequire("5ZPtT");


var $eWwvy = parcelRequire("eWwvy");


var $39rFu = parcelRequire("39rFu");





var $cBuRD = parcelRequire("cBuRD");





var $eIKcA = parcelRequire("eIKcA");





var $ezLwY = parcelRequire("ezLwY");

/**
 * shortcutContext('global') or shortcutContext(['global', 'viewcontent'])
 * @param context
 * @returns {Function}
 */ function $089e60b6c1a73ffc$var$shortcutContext(context) {
    return (BaseComponent)=>{
        class ShortcutContextComponent extends (0, $cozmU.Component) {
            componentDidMount() {
                (0, $ezLwY.enableContext)(context);
            }
            componentWillUnmount() {
                (0, $ezLwY.disableContext)(context);
            }
            render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BaseComponent, this.props);
            }
        }
        ShortcutContextComponent.displayName = `ShortcutContextComponent(${BaseComponent.displayName || BaseComponent.name})`;
        return ShortcutContextComponent;
    };
}
var $089e60b6c1a73ffc$export$2e2bcd8739ae039 = $089e60b6c1a73ffc$var$shortcutContext;



var $jmjWc = parcelRequire("jmjWc");


const $f05a18473f890654$export$ffff49ea750347f8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "3CTAv",
    name: "StandaloneRestrictedPageOrSpace",
    loader: async ()=>(await (parcelRequire("49fir"))).StandaloneRestrictedPageOrSpace
});



var $jwv1p = parcelRequire("jwv1p");


var $arkw6 = parcelRequire("arkw6");


var $3j0Cc = parcelRequire("3j0Cc");


var $4QflW = parcelRequire("4QflW");





var $6a18f8a58973e042$exports = {};

var $bPgnM = parcelRequire("bPgnM");


var $j5066 = parcelRequire("j5066");


var $2Ryc1 = parcelRequire("2Ryc1");


var $dojlP = parcelRequire("dojlP");

/**
 * Checks if `string` ends with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=string.length] The position to search up to.
 * @returns {boolean} Returns `true` if `string` ends with `target`,
 *  else `false`.
 * @example
 *
 * _.endsWith('abc', 'c');
 * // => true
 *
 * _.endsWith('abc', 'b');
 * // => false
 *
 * _.endsWith('abc', 'b', 2);
 * // => true
 */ function $6a18f8a58973e042$var$endsWith(string, target, position) {
    string = $dojlP(string);
    target = $j5066(target);
    var length = string.length;
    position = position === undefined ? length : $bPgnM($2Ryc1(position), 0, length);
    var end = position;
    position -= target.length;
    return position >= 0 && string.slice(position, end) == target;
}
$6a18f8a58973e042$exports = $6a18f8a58973e042$var$endsWith;



var $jzEl8 = parcelRequire("jzEl8");

const $9117dce6b863f439$var$LINKS_TO_BE_REMOVED = [
    '#action-page-permissions-link'
];
const $9117dce6b863f439$var$LINKS_TO_BE_REMOVED_ON_PAGE_INFORMATION = [
    '#page-favourite',
    '#action-menu-link'
];
const $9117dce6b863f439$var$replacedPlaceholder = {
    elementName: 'span',
    attributes: {
        style: `display: none`
    }
};
function $9117dce6b863f439$export$9e2c81a475b5d1b8() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jzEl8.LegacyDOMBridge), {
        selectors: $9117dce6b863f439$var$LINKS_TO_BE_REMOVED,
        attempts: 100,
        retryDelay: 500,
        portalNode: null,
        replacePlaceholderWith: $9117dce6b863f439$var$replacedPlaceholder
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6a18f8a58973e042$exports)))(window.location.pathname, '/pages/viewinfo.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jzEl8.LegacyDOMBridge), {
        selectors: $9117dce6b863f439$var$LINKS_TO_BE_REMOVED_ON_PAGE_INFORMATION,
        attempts: 100,
        retryDelay: 500,
        replacePlaceholderWith: $9117dce6b863f439$var$replacedPlaceholder,
        portalNode: null
    }));
}












var $9DHhW = parcelRequire("9DHhW");


var $9wGTI = parcelRequire("9wGTI");








var $e4o8D = parcelRequire("e4o8D");





const $b82761c2a95901d5$export$18a8a22069631f81 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "kdP2C",
    loader: async ()=>(await (parcelRequire("jBEZO"))).ArchiveSpacePortal,
    name: 'ArchiveSpacePortal'
});






const $e87d969ba20a20a0$export$854f67824ef9311 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "P3ji1",
    loader: async ()=>(await (parcelRequire("5WXBa"))).DeleteSpacePortal,
    name: 'DeleteSpacePortal'
});






const $a6c6b76f924ecb80$export$b4b583c595949768 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BlJ6r",
    name: "LazySpaceSettingsForgeExtensionPortal",
    loader: async ()=>(await (parcelRequire("lJZup"))).SpaceSettingsForgeExtensionPortal
});
$a6c6b76f924ecb80$export$b4b583c595949768.displayName = 'LazySpaceSettingsForgeExtensionPortal';



var $7QM6o = parcelRequire("7QM6o");


var $feuG2 = parcelRequire("feuG2");





const $b270d87888ab1caf$export$cca256d7c562dc07 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "mTzRP",
    loader: async ()=>(await (parcelRequire("10Uyw"))).SpaceTrashPortal,
    name: 'SpaceTrashPortal'
});






const $d2b3f21ec8a84bb2$export$2c12a08ca2f15d0e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wu877",
    name: "SiteSettingsHelpPanelLink",
    loader: async ()=>(await (parcelRequire("eiv96"))).SiteSettingsHelpPanelLink
});






const $406f60e313bf3a3f$export$b52880da76836cd4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "h3QZB",
    name: "BackupManagerButton",
    loader: async ()=>(await (parcelRequire("e0okQ"))).BackupManagerButton
});



var $14QAi = parcelRequire("14QAi");


var $ep3mz = parcelRequire("ep3mz");

/* PdfBannerPortal.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");





var $6mKj3 = parcelRequire("6mKj3");

const $530cf45a0f14746c$var$PDF_BANNER_PORTAL_ID = 'pdf-export-banner-root';
const $530cf45a0f14746c$var$i18n = (0, $kSwu1.defineMessages)({
    bannerMessage: {
        id: "pdf-export.banner.message",
        defaultMessage: "We've received your print request. To maintain your page's format, we're exporting it to a PDF for you to download and print."
    }
});
const $530cf45a0f14746c$var$styles = {
    bannerStyles: "_4FKVYE5zaO _0KLXrugozt _39HuIbz8Lp _1ANEUSLRg7"
};
const $530cf45a0f14746c$var$PdfBanner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $530cf45a0f14746c$var$styles.bannerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.inverse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $530cf45a0f14746c$var$i18n.bannerMessage)));
const $530cf45a0f14746c$export$57cc11a378563774 = ()=>{
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    if (!(0, $6mKj3.expValEquals)('afm-enable-command-p-reroute', 'isEnabled', true)) return null;
     // only inject if ?showPdfBanner=true
    if (queryParams.showPdfBanner !== 'true') return null;
     // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    let targetElement = document.getElementById($530cf45a0f14746c$var$PDF_BANNER_PORTAL_ID); // if the target doesn't exist, create and insert it before <main>
    if (!targetElement) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const main = document.querySelector('main#main');
        if (main && main.parentElement) {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            targetElement = document.createElement('div');
            targetElement.id = $530cf45a0f14746c$var$PDF_BANNER_PORTAL_ID;
            main.parentElement.insertBefore(targetElement, main);
        }
    } // if no anchor could be found, bail
    if (!targetElement) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($530cf45a0f14746c$var$PdfBanner, null), targetElement);
};



const $76c1a3880217c32d$var$LegacyAttachmentForgeActionsPortalLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "9miZ5",
    name: "LegacyAttachmentForgeActionsPortalLoader",
    loader: async ()=>(await (parcelRequire("3WPwA"))).LegacyAttachmentForgeActionsPortal
});
const $76c1a3880217c32d$var$i18n = (0, $kSwu1.defineMessages)({
    importingTemplates: {
        id: "standalone-navigation.importing.templates",
        defaultMessage: "More about importing templates"
    }
});
const $76c1a3880217c32d$var$LEGACY_ATTACHMENTS_PATH = '/pages/viewpageattachments.action';
const $76c1a3880217c32d$var$getLegacyAttachmentsSearch = ({ pathname: pathname, search: search, renderServerPlaceholder: renderServerPlaceholder })=>{
    if (pathname?.includes($76c1a3880217c32d$var$LEGACY_ATTACHMENTS_PATH)) return search ?? '';
    if (!renderServerPlaceholder && window.location.pathname.includes($76c1a3880217c32d$var$LEGACY_ATTACHMENTS_PATH)) return window.location.search;
    return undefined;
};
const $76c1a3880217c32d$var$LegacyAttachmentForgeActionsPortal = ({ spaceKey: spaceKey, pathname: pathname, search: search })=>{
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const legacyAttachmentsSearch = $76c1a3880217c32d$var$getLegacyAttachmentsSearch({
        pathname: pathname,
        search: search,
        renderServerPlaceholder: renderServerPlaceholder
    });
    const contentId = legacyAttachmentsSearch ? new URLSearchParams(legacyAttachmentsSearch).get('pageId') ?? undefined : undefined;
    if (legacyAttachmentsSearch == null || !(0, $9wGTI.fg)('forge_attachment_display_conditions')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ep3mz.PageStateContainer), {
        contentId: contentId,
        spaceKey: spaceKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($76c1a3880217c32d$var$LegacyAttachmentForgeActionsPortalLoader, {
        spaceKey: spaceKey
    }));
};
$76c1a3880217c32d$var$LegacyAttachmentForgeActionsPortal.propTypes = {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    pathname: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    search: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string
};
const $76c1a3880217c32d$export$fc287ab47b11c4ec = ({ spaceKey: spaceKey, isSpaceSettingsScreen: isSpaceSettingsScreen })=>{
    const { location: { pathname: pathname, search: search } } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const spaceId = (0, $7QM6o.useSpaceId)(spaceKey);
    (0, $cozmU.useEffect)(()=>{
        const { section: section, screen: screen } = (0, $14QAi.getRouteData)(pathname);
        // We only want analytics for IPH specific routes for now
        if (screen !== 'notTracked') createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: screen,
                attributes: {
                    section: section
                }
            }
        }).fire();
    }, [
        pathname,
        createAnalyticsEvent,
        spaceId
    ]);
    return pathname && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, isSpaceSettingsScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ep3mz.PageStateContainer), {
        spaceKey: spaceKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $feuG2.SpaceSettingsNavigationV2Portal), {
        spaceKey: spaceKey
    })) : null, pathname.includes('/spaces/archivespace.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b82761c2a95901d5$export$18a8a22069631f81), {
        spaceKey: spaceKey,
        pathname: pathname
    }), pathname.includes('/spaces/removespace.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e87d969ba20a20a0$export$854f67824ef9311), {
        spaceKey: spaceKey,
        pathname: pathname
    }), pathname.includes('/pages/viewtrash.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b270d87888ab1caf$export$cca256d7c562dc07), {
        spaceKey: spaceKey
    }), pathname.includes('/templatePackage/configurePlugin.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d2b3f21ec8a84bb2$export$2c12a08ca2f15d0e), {
        articleId: "7p0QTJJI0VkoU49M4GzKH2",
        articleTopic: "admin-import-templates",
        portalTargetId: "site-settings-import",
        buttonContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $76c1a3880217c32d$var$i18n.importingTemplates),
        pathname: pathname,
        routeGroup: "site-settings",
        routeName: "undefined"
    }), pathname.includes('/plugins/servlet/ondemandbackupmanager') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $406f60e313bf3a3f$export$b52880da76836cd4), {
        pathname: pathname
    }), pathname.includes('spaces/flyingpdf/pdfpageexport.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $530cf45a0f14746c$export$57cc11a378563774), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($76c1a3880217c32d$var$LegacyAttachmentForgeActionsPortal, {
        spaceKey: spaceKey,
        pathname: pathname,
        search: search
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6c6b76f924ecb80$export$b4b583c595949768), {
        spaceKey: spaceKey
    }));
};
// needed for react-proptypes warning
$76c1a3880217c32d$export$fc287ab47b11c4ec.propTypes = {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    isSpaceSettingsScreen: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};


var $7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation;
function $7c0ba11073bcb5f1$var$_defineProperty(e, r, t) {
    return (r = $7c0ba11073bcb5f1$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $7c0ba11073bcb5f1$var$_toPropertyKey(t) {
    var i = $7c0ba11073bcb5f1$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $7c0ba11073bcb5f1$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $7c0ba11073bcb5f1$var$TopNavSpacer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbvLZJ _39xV02N91d _0jFU0VG9sM",
            __cmplp.className
        ])
    });
});
var $7c0ba11073bcb5f1$export$2e2bcd8739ae039 = (0, $089e60b6c1a73ffc$export$2e2bcd8739ae039)('global')(($7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation = class StandaloneConfluenceNavigation extends (0, $cozmU.PureComponent) {
    componentDidMount() {
        const { isAdminScreen: isAdminScreen } = this.props; // if admin screen, show content as we mount
        if (isAdminScreen) (0, $8bee1fe38b9eef04$export$4011f4c5a8044281)();
        else setTimeout((0, $8bee1fe38b9eef04$export$4011f4c5a8044281), 300);
        (0, $ge2sX.getSessionData)();
    }
    render() {
        const { isAdminScreen: isAdminScreen, isSpaceSettingsScreen: isSpaceSettingsScreen, isSpaceScreen: isSpaceScreen, route: route, spaceKey: spaceKey } = this.props;
        let navView;
        if (isSpaceSettingsScreen) navView = (0, $lFjPc.CONTAINER_ADMIN_HOME_ID);
        else if (isSpaceScreen) navView = (0, $lFjPc.CONTAINER_HOME_ID);
        else if (isAdminScreen) navView = (0, $lFjPc.ADMIN_HOME_ID);
        else if (route?.name !== (0, $1NBp8.EXTERNAL_SHARE).name) // XXX EXTERNAL_SHARE does not have the typical navigation.
        navView = (0, $lFjPc.PRODUCT_HOME_ID);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f05a18473f890654$export$ffff49ea750347f8), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $76c1a3880217c32d$export$fc287ab47b11c4ec), {
            spaceKey: spaceKey,
            isSpaceSettingsScreen: isSpaceSettingsScreen
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aeSHO.CopySpacePermissionsForLegacyNewSpace), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpWmZ.default), {
            client: (0, $04e9M.getAnalyticsWebClient)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39rFu.EditPageLoadingContextProvider), {
            nativeEditorComponentsPreloader: (0, $eXODy.nativeEditorComponentsPreloader),
            livePageComponentsPreloader: (0, $jwv1p.preloadLivePagesComponents)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).DISCO
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iV00x.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJ8K8.Screen), {
            screenEvent: {
                name: 'serverRenderedScreen',
                attributes: {
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            },
            pageState: {
                spaceKey: spaceKey,
                contentId: (0, $iJ8K8.SPACE_OVERVIEW)
            }
        }, navView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ZPtT.PageLayout), {
            view: navView,
            isSpaceSettingsScreen: isSpaceSettingsScreen,
            standalone: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NAPtM.CreateDialogContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arkw6.LazyCreateDialogQueryRenderer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3j0Cc.LazyCreateDialogBlueprintWizardRenderer), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4QflW.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eIKcA.default), null), isSpaceSettingsScreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eWwvy.EditSpaceLogo), {
            spaceKey: spaceKey,
            entryPoint: "spaceSettings"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9117dce6b863f439$export$9e2c81a475b5d1b8), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cBuRD.NotificationLandedEvent), null)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f60f9bb0af41c642$export$ddc928ad192d2b94), null));
    }
    constructor(...args){
        super(...args);
        $7c0ba11073bcb5f1$var$_defineProperty(this, "spacer", ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7c0ba11073bcb5f1$var$TopNavSpacer, {
                "data-test-id": "top-nav-spacer"
            }));
    }
}, $7c0ba11073bcb5f1$var$_defineProperty($7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation, "displayName", 'StandaloneConfluenceNavigation'), $7c0ba11073bcb5f1$var$_defineProperty($7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation, "propTypes", {
    isAdminScreen: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    isSpaceScreen: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    isSpaceSettingsScreen: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    route: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string
}), $7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation));


const $fe485fa379bdff14$var$getSpaceKey = (state)=>{
    const routeParams = (0, $iyEDi.getRouteParams)(state);
    return (0, $iyEDi.routerStateExists)(state) && routeParams && routeParams.spaceKey || state.meta.get('space-alias') || state.meta.get('space-key');
};
const $fe485fa379bdff14$var$mapStateToProps = (state, props)=>{
    const { location: location, matchRoute: matchRoute } = props;
    const isSpaceScreen = state.meta.get('is-space-page') === 'true' || (0, $gnnzK.isContentTypeOf)('page', state) || (0, $gnnzK.isContentTypeOf)('blogpost', state);
    //On the DELETE_SPACE_LEGACY path the space is already deleted but certain queries
    //use the spaceKey. Set spaceKey to null if on this path
    const route = matchRoute(`${location.pathname}${location.search}${location.hash}`);
    const spaceKey = route?.name === (0, $1NBp8.DELETE_SPACE_LEGACY).name ? null : $fe485fa379bdff14$var$getSpaceKey(state);
    return {
        isAdminScreen: state.meta.get('is-admin-page') === 'true',
        isSpaceScreen: isSpaceScreen,
        isSpaceSettingsScreen: state.meta.get('is-space-tool-page') === 'true',
        route: route,
        spaceKey: spaceKey
    };
};
var $fe485fa379bdff14$export$2e2bcd8739ae039 = (0, $bEYte.connect)($fe485fa379bdff14$var$mapStateToProps)((0, $7c0ba11073bcb5f1$export$2e2bcd8739ae039));


/**
 * setupUFOGlobalErrorHandler MUST be the first thing executed before any rendering operations.
 * This ensures we catch and track any errors that occur during the app's initialization,
 * including async operations and React rendering. Moving this call later would risk missing
 * early errors.
 * it provides ufo:errors:globalCount is the count of all errors which occurred on the client all up
 */ (0, $B8b0t.default)();
const $f5e2aff200456a49$var$sessionDataPromise = (async ()=>{
    (0, $hp2SH.getApolloClient)();
    try {
        const sessionData = await (0, $aXEzU.getSessionDataAndInitializeStatsig)();
        // Initialize browser storage controls after Statsig is ready (for proper feature gate evaluation)
        // This must happen before initializeStorageManager
        await (0, $7ZzSP.initializeBootstrapStorage)({
            userId: sessionData.userId,
            cloudId: sessionData.cloudId
        });
        const { userId: userId, isLicensed: isLicensed, monolithRegion: monolithRegion } = sessionData;
        (0, $8PKGr.initializeAggRegionSteeringHint)(monolithRegion);
        (0, $xwvlW.initializePreloaderFnContext)(sessionData);
        await (0, $17wUi.initializeStorageManager)({
            userId: userId,
            isLicensed: isLicensed
        });
        (0, $gnYQc.applyPersistedStatsigOverrides)();
        return sessionData;
    } catch  {
        // For the same reasons as in the non-standalone case documented in the
        // counterpart of this file which is
        // confluence/packages/confluence-frontend-server/src/index.js at the moment
        return (0, $iC5L0.getEmptySessionData)();
    }
})();
const $f5e2aff200456a49$var$translationPromise = (0, $awd1Q.loadTranslation)((0, $7RVQB.lazyLanguage));
Promise.all([
    $f5e2aff200456a49$var$sessionDataPromise,
    $f5e2aff200456a49$var$translationPromise
]).then(([sessionData])=>{
    const browserNotSupportedCheck = (0, $2DVQX.coreBrowserNotSupported)();
    // the only requirement for BrowserNotSupported to render is the translationPromise
    if (browserNotSupportedCheck) {
        // the monolith attaches this id to the body here: confluence-core/confluence-webapp/src/main/webapp/decorators/main.vmd:62
        const documentBody = document.getElementById('com-atlassian-confluence');
        // eslint-disable-next-line react/no-deprecated
        return void (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9j59h.BrowserNotSupportedLoader), null), documentBody);
    }
    (0, $7LuKf.initialization)(sessionData);
    (0, $8bee1fe38b9eef04$export$ed04e7f6ba662aee)();
    (0, $d4f95b5cede9219f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e6baa9171970034d$export$11eb671888ed6e7d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ location: location, matchRoute: matchRoute })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe485fa379bdff14$export$2e2bcd8739ae039), {
            apolloClient: (0, $hp2SH.getApolloClient)(),
            location: location,
            matchRoute: matchRoute
        }))), 'ui-global-sidebar-section', true);
});
 }, ["7EorR","hcljt","fntNA","aZinD","eiF7i","hhss7","ffEVr","1yVM6","1qlDN","aEiTV","fINdN","6XCf4","6wr18","ht0V6"]);

$parcel$global.rlb("3pblT")
//# sourceMappingURL=standalone-navigation-jquery3.80fbd0fe.js.map
